import {documentReady, debouncer, index} from '../Utility/utils';

documentReady(event => {
  // Hero Anchor Nav
  const heroNav = document.querySelector('.hero__nav');
  if(!!heroNav){
    const navLabels = heroNav.querySelector('.hero__nav_labels');
    const navItems = navLabels.querySelectorAll('li');
    const body = document.querySelector('body');

    // Toggle Hero Nav on button click
    const toggleHeroNav = (item) => {
      // Don't toggle nav open if a numeric link is clicked
      const parentLi = item.closest('li');
      if(!!parentLi && parentLi.classList.contains('numeric') && !navLabels.classList.contains('active')){
        return;
      }

      // Don't toggle nav if we're in the mobile view
      const bottomPosition = window.getComputedStyle(heroNav).bottom;
      if(bottomPosition === '0px'){
        return;
      }

      if(navLabels.classList.contains('active')){
        navLabels.classList.remove('active');
        navLabels.setAttribute('aria-hidden', 'true');
      }
      else {
        navLabels.classList.add('active');
        navLabels.setAttribute('aria-hidden', 'false');
      }
    }

    // Set active state based on window size
    const heroNavWindowResize = () => {
      const bottomPosition = window.getComputedStyle(heroNav).bottom;
      if(bottomPosition === '0px'){
        if(navLabels.classList.contains('active')){
          navLabels.classList.remove('active');
        }
        if(navLabels.getAttribute('aria-hidden') == 'true'){
          navLabels.setAttribute('aria-hidden', 'false');
        }
      }
      else if(!navLabels.classList.contains('active') && navLabels.getAttribute('aria-hidden') == 'false'){
        navLabels.setAttribute('aria-hidden', 'true');
      }
    }
    heroNavWindowResize();

    // Set active nav item based on scroll position
    let activeIndex = 1;
    const setActiveNavItem = () => {
      const adminBarEl = document.getElementById("wpadminbar");
      const adminBarHeight = !!adminBarEl ? adminBarEl.offsetHeight : 0;
      const currentScroll = window.pageYOffset | document.body.scrollTop;
      const windowBottom = currentScroll + window.innerHeight - adminBarHeight;
      const bodyHeight = body.offsetHeight;

      navItems.forEach(item => {
        // Get the link target
        const link = item.querySelector('a');
        const href = link.getAttribute('href');
        const hash = href.substring(href.indexOf("#"));
        const hashTarget = document.getElementById(hash.substring(1));
        const currentIndex = index(item);

        if (hash !== "#" && !!hashTarget) {
          const targetTop = Math.round(hashTarget.getBoundingClientRect().top) + currentScroll - adminBarHeight;
          const targetBottom = targetTop + hashTarget.offsetHeight;

          // Get the active index based on scroll position
          if(windowBottom >= bodyHeight){
            activeIndex = navItems.length;
          }
          else if(targetTop <= currentScroll && targetBottom > currentScroll){
            activeIndex = currentIndex;
          }
        }
      });

      // if(!activeIndex){
      //   activeIndex = 1;
      // }

      let i = 0;
      const numberedListItems = heroNav.querySelectorAll('.hero__nav_item.numeric');
      numberedListItems.forEach(item => {
        i++;
        if(i == activeIndex){
          item.classList.add('active');
        } else if(item.classList.contains('active')){
          item.classList.remove('active');
        }
      });
      i = 0;
      navItems.forEach(item => {
        i++;
        if(i == activeIndex){
          item.classList.add('active');
        } else if(item.classList.contains('active')){
          item.classList.remove('active');
        }
      });
    }
    setActiveNavItem();

    // toggle nav on link clicks
    const navLinks = heroNav.querySelectorAll('a');
    navLinks.forEach(item => {
      item.addEventListener('click', function(){
        toggleHeroNav(item);
      });
    });

    // Resize modals on window resize
    window.addEventListener('resize', debouncer(function(){
      heroNavWindowResize();
    }, 15));

    window.addEventListener('scroll', debouncer(function(){
      setActiveNavItem();
    }, 5));

  }
});
